/**
 * Production-safe logger utility
 * - In development: logs to console
 * - In production: silences logs (or could send to remote logging service)
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isStaging = process.env.REACT_APP_URI === 'staging';

// Enable logging in development and staging, disable in production
const shouldLog = isDevelopment || isStaging;

/**
 * Log informational messages (silenced in production)
 */
export const log = (...args) => {
  if (shouldLog) {
    console.log(...args);
  }
};

/**
 * Log warning messages (silenced in production)
 */
export const warn = (...args) => {
  if (shouldLog) {
    console.warn(...args);
  }
};

/**
 * Log error messages (always logged, even in production)
 * Errors should always be visible for debugging production issues
 */
export const error = (...args) => {
  console.error(...args);
};

/**
 * Log debug messages (only in development, not staging)
 */
export const debug = (...args) => {
  if (isDevelopment) {
    console.log('[DEBUG]', ...args);
  }
};

// Default export for convenience
const logger = { log, warn, error, debug };
export default logger;
